import PromoCode from './PromoCode';

export default class Components {
  promoCode = new PromoCode();
}
